import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as p, f as d } from "../../../../create-component-CBAeEoQ6.js";
import { CardTitle as i } from "../../CardTitle/index.js";
import { CardMeta as j } from "../../CardMeta/index.js";
const N = p(
  "ProductCardContent",
  d(
    ({
      as: e,
      children: l,
      className: a,
      horizontal: s = !1,
      image: o = null,
      meta: u = null,
      rating: n = null,
      title: c = null,
      ...t
    }, x) => {
      const f = e || "div";
      return /* @__PURE__ */ r.jsx(
        f,
        {
          className: m("cur-grow cur-pb-3", a),
          ref: x,
          ...t,
          children: /* @__PURE__ */ r.jsxs("div", { className: s ? "cur-flex cur-gap-[20px]" : "cur-block", children: [
            /* @__PURE__ */ r.jsx("div", { className: s ? "cur-w-1/2" : "", children: o }),
            /* @__PURE__ */ r.jsx("div", { className: "cur-my-2 cur-flex cur-w-full cur-items-start cur-justify-between cur-gap-3 cur-px-1", children: /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-flex-1 cur-flex-col cur-flex-wrap cur-gap-2", children: [
              c && (typeof c == "string" ? /* @__PURE__ */ r.jsx(i, { children: c }) : c),
              typeof u == "string" ? /* @__PURE__ */ r.jsx(j, { children: u }) : u,
              n
            ] }) }),
            !s && l ? /* @__PURE__ */ r.jsx("div", { className: "cur-flex cur-w-full cur-flex-col cur-gap-4 cur-px-1 [&>div]:cur-mb-0 [&_p]:cur-mb-2 last:[&_p]:cur-mb-0", children: l }) : null
          ] })
        }
      );
    }
  )
);
export {
  N as ProductCardContent
};
//# sourceMappingURL=index.js.map
